export default "__VITE_ASSET__OKc2clvv__"